import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';
import { ANY_SPORT_LINEUPS_ARENA } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { LineupMode } from '#src/lib/gameMode.ts';

export const useCurrentLineupMode = (): LineupMode => {
  const { pathname } = useLocation();
  const { matchAnySportPath } = useSportContext();

  if (matchAnySportPath(catchAll(ANY_SPORT_LINEUPS_ARENA), pathname)) {
    return LineupMode.ARENA;
  }

  return LineupMode.PRO;
};
